import { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { TagManager } from "@dealer-center/core-third-party-gtm";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";
import { useControlcenterAPIInterface } from "@dealer-center/ddc-pages-controlcenter-fetch";
import { MessagePage } from "@dealer-center/core-custom-components";
import { ControlCenterContainer } from "./components/ControlCenterContainer";
import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";

export const PagesControlcenterApp = () => {
  const location = useLocation();
  const userState = useGetUser();
  const [locale, setLocale] = useState("en-US");
  const { data: userEntity } = userState;

  useEffect(() => {
    document.title = "ControlCenter";
  }, []);

  useEffect(() => {
    const newLocale = Locale.getLocale();

    if (locale !== newLocale) {
      Locale.change(newLocale);
      setLocale(newLocale);
    }
  }, [locale]);

  useEffect(() => {
    TagManager.event({
      eventName: "page_view"
    });
  }, [location]);

  const { asAccount, asUser } = useParams();

  const { data: ccUserInfo } = useControlcenterAPIInterface({
    asAccount,
    asUser
  });

  useEffect(() => {
    Locale.setLabelsOnce(LABELS);
  }, []);

  if (!ccUserInfo) {
    return (
      <div data-testid="ddc-page">
        <MessagePage
          actionName={"Loading user permissions"}
          message="Loading user permissions"
        />
      </div>
    );
  }
  return (
    <ControlCenterContainer>
      <Outlet context={{ ccUserInfo, userEntity }} />
    </ControlCenterContainer>
  );
};
